function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M23.5004 0H15.667V7.85049H23.5004V0Z",
  fill: "#4169E1"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M15.6664 0H7.83301V7.85049H15.6664V0Z",
  fill: "#4169E1"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M7.83337 0L3.91668 3.92525L1.95834 5.88787L0 7.85049H7.83337V0Z",
  fill: "#4169E1"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M15.6664 16.1495H7.83301V24H15.6664V16.1495Z",
  fill: "#4FD1C5"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M23.5004 11.6636H15.667V16.1496H23.5004V11.6636Z",
  fill: "#4FD1C5"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M7.83337 7.85059H0V11.6637H7.83337V7.85059Z",
  fill: "#4169E1"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M7.83337 16.1495H0V24H7.83337V16.1495Z",
  fill: "#4FD1C5"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M23.5004 16.1495H15.667V24L19.5837 20.0748L23.5004 16.1495Z",
  fill: "#4FD1C5"
});

var SvgLogo = function SvgLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo.67a2dd43.svg";
export { ForwardRef as ReactComponent };